import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import {
    Breadcrumb,
    Icon,
    Card,
    Row,
    Col,
    Divider,
    Checkbox,
    InputNumber,
    Input,
    Button,
    message,
    Tooltip,
    Form
} from 'antd';
import {connect} from 'react-redux';
import * as moment from 'moment';
import {
    fetchLandlords,
    updateLandlord,
    uploadDocument,
    deleteDocument
} from '../actions';
import Map from './Map';
import Document from './Document';
message.config({top: 11});

const FormItem = Form.Item;
const { TextArea } = Input;

class Landlord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null,
            viewNotes: false,
            notes: '',
            editVisible: false,
            edit: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {landlord, isFetching} = nextProps;
        if (isFetching || landlord.isFetching) {
            return null;
        }

        if (landlord.error) {
            return {serverErrors: landlord.error}
        }
        if (!landlord.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    renderBreadcrump() {
        const {match: {params: {id}}, location: {state: {from} = {}}} = this.props;
        return (
            <Breadcrumb style={{marginBottom: 16}}>
                <Breadcrumb.Item>
                    <Link to={{
                        pathname: '/admin/landlords',
                        search: from
                    }}><Icon type='solution'/> Landlords</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{id}</Breadcrumb.Item>
            </Breadcrumb>
        );
    }
    static notifySuccess() {
        message.success('Successfully updated')
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}} = this;
        if (!serverErrors) {
            this.setState({edit: false});
            Landlord.notifySuccess();
            return;
        }

        const {res: {errors, message}} = serverErrors;
        Landlord.notifyError(errors || message);
    }
    handleSubmit(e){
        e.preventDefault();
        const {form, updateLandlord, landlord: {id}} = this.props;
        return form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            return updateLandlord(id, values).then(() => this.handlePostSubmit(values));
        });
    }
    renderProfile() {
        const {
            id,
            business_name,
            latitude: lat,
            longitude: lng,
            gas_safe_registered,
            gas_safe_registration_no,
            documents = [],
            isFetching,
            approved_by,
            approved,
            contract_start_date,
            start_number,
            number_of_active_badges,
            updated_at
        } = this.props.landlord;
        const { getFieldDecorator } = this.props.form;
        const {next: {id: next}, previous: {id: prev}, location: {state: {from} = {}}} = this.props;
        const {uploadDocument, deleteDocument} = this.props;

        const Navigation = () => (
            <Button.Group>
                <Button disabled={!prev}>
                    <Link to={{
                        pathname: `/admin/landlords/${prev}`,
                        state: {from}
                    }}><Icon type="left" /></Link>
                </Button>
                <Button disabled={!next}>
                    <Link to={{
                        pathname: `/admin/landlords/${next}`,
                        state: {from}
                    }}><Icon type="right" /></Link>
                </Button>
            </Button.Group>
        );

        const postUploadHandler = (file, onSuccess, onError) => {
            const {state: {serverErrors}} = this;
            if (!serverErrors) {
                file.status = 'done';
                return onSuccess(file);
            }

            const {res: {errors, message}} = serverErrors;
            file.status = 'error';
            file.response = message;
            Landlord.notifyError(errors);
            return onError(file);
        };
        const handleUpload = ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            if (data) {
                Object.keys(data).map(key => {
                    formData.append(key, data[key]);
                });
            }
            formData.append(filename, file);

            return uploadDocument(id, formData).then(() => postUploadHandler(file, onSuccess, onError));
        };
        const getDocument = (type) => {
            return {...documents.find(doc => doc.doc_type === type), isFetching};
        };
        const onDelete = (doc) => {
            return deleteDocument(id, doc.uid);
        };
        const toggleEdit = (e) => {
            e.preventDefault();

            this.setState({
                edit: !this.state.edit
            });
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>{business_name}</span>
                {!this.state.edit ? (
                    <Tooltip title="Edit Details">
                        <Link to="#" onClick={toggleEdit}> <Icon type="edit"/></Link>
                    </Tooltip>
                ) : null}
            </div>
        );

        const textField = (field, required = true) => {
            const val = this.props.landlord[field];
            if (!this.state.edit) return val;

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: val,
                        rules: [{ required, whitespace: true }],
                    })(
                        <Input size="small"/>
                    )}
                </FormItem>
            )
        };

        const numberField = (field, field2) => {
            const val = this.props.landlord[field] || this.props.landlord[field2] || 0;
            if (!this.state.edit) return val;

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: val,
                        rules: [{ required: true }],
                    })(
                        <InputNumber size="small" style={{width: '100%'}}/>
                    )}
                </FormItem>
            )
        };

        const dateField = (field) => {
            return field && moment(field.date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        };

        const postCodeField = (field) => {
            const val = this.props.landlord[field];
            if (!this.state.edit) return val;

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: val,
                        normalize: value => {
                            if (!value) return "";
                            return value.replace(/[ ]+/g, '')
                                .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2")
                                .toUpperCase();
                        },
                        rules: [
                            { pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}', message: 'Invalid post code', transform: value => {
                                return value.replace(/[ ]+/g, '')
                                    .replace(/([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)([0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})/, "$1 $2");
                            }},
                            { required: true, whitespace: true }
                        ],
                    })(
                        <Input size="small"/>
                    )}
                </FormItem>
            )
        };

        const phoneNumberField = field => {
            const val = this.props.landlord[field];
            if (!this.state.edit) return val;

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: val,
                        rules: [
                            { pattern: /\d{11}$/ },
                            { required: true, whitespace: true }
                        ],
                    })(
                        <Input size="small"/>
                    )}
                </FormItem>
            )
        };

        const textAreaField = field => {
            const val = this.props.landlord[field];
            if (!this.state.edit) return val;

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: val
                    })(
                        <TextArea rows={4}/>
                    )}
                </FormItem>
            )
        };

        return (
            <Form onSubmit={this.handleSubmit.bind(this)} id="landlord-edit-form">
                <Card title={title()} loading={this.props.isFetching} bordered={false} extra={<Navigation/>}>
                    <Row gutter={16}>
                        <Col span={16}>
                            <Row gutter={16}>
                                <Col span={4}><p>Approved By: </p></Col><Col span={8}>{approved_by && approved_by.name}</Col>
                                <Col span={5}><p>Approved On: </p></Col><Col span={7}>{approved && moment(approved.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}><Link to="#">Open in Landlord portal <Icon type="link"/></Link></Col>
                                <Col span={5}><p>Last Edited On:</p></Col><Col span={7}>{updated_at && moment(updated_at.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Col>
                            </Row>
                            <Divider orientation="left">Contact Details</Divider>
                            <Row gutter={16}>
                                <Col span={4}><p>Business Name: </p></Col><Col span={8}>{business_name}</Col>
                                <Col span={5}><p>Main Contact Name: </p></Col><Col span={7}>{textField('contact_name')}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={4}><p>Address Line 1: </p></Col><Col span={8}>{textField('address_line_1')}</Col>
                                <Col span={5}><p>Main Contact Tel: </p></Col><Col span={7}>{phoneNumberField('phone_number')}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={4}><p>Address Line 2: </p></Col><Col span={8}>{textField('address_line_2')}</Col>
                                <Col span={5}><p>Main Contact Email: </p></Col><Col span={7}>{textField('email')}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={4}><p>Address Line 3: </p></Col>
                                <Col span={8}>{textField('address_line_3', false)}</Col>

                                <Col span={5}><p>Gas Safe Registered: </p></Col>
                                <Col span={7}><Checkbox disabled checked={gas_safe_registered}/></Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={4}><p>Post Code: </p></Col><Col span={8}>{postCodeField('post_code')}</Col>
                                <Col span={5}><p>Gas Safe Registration No: </p></Col>
                                <Col span={7}>{gas_safe_registered ? gas_safe_registration_no : textField('gas_safe_registration_no')}</Col>
                            </Row>
                            <Divider orientation="left">Contract Details</Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Cost Per Property (&pound;): </p></Col>
                                        <Col span={12}>{numberField('cost_per_property', 'property_cost_quoted')}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Contract Start Date: </p></Col>
                                        <Col span={12}>{dateField(contract_start_date)}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Cost Per Badge (&pound;): </p></Col>
                                        <Col span={12}>{numberField('cost_per_badge', 'badge_cost_quoted')}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Number Of Badges Issued: </p></Col>
                                        <Col span={12}>{numberField('number_of_badges_issued', 'number_of_properties')}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Badge Start No. : </p></Col>
                                        <Col span={12}>{start_number}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Badge End No. : </p></Col>
                                        <Col span={12}>{textField('end_number', false)}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Number Of Active Badges: </p></Col>
                                        <Col span={12}>{number_of_active_badges}</Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col span={12}><p>Invoice This Month To Date (&pound;): </p></Col>
                                        <Col span={12}>0</Col>
                                    </Row>
                                </Col>
                                <Col span={12}>
                                    <p>Notes</p>
                                    {textAreaField('notes')}
                                </Col>
                            </Row>
                            {this.state.edit ? <Divider /> : ''}
                            {this.state.edit ? (
                                <div>
                                    <Button size='large' onClick={toggleEdit} style={{marginRight: 10}}>Cancel</Button>
                                    <Button type='primary' size='large' htmlType="submit">Update</Button>
                                </div>
                            ) : ''}
                        </Col>
                        <Col span={8} >
                            <Row>
                                <Col span={24}>
                                    <Map {...{lat, lng}}/>
                                </Col>
                            </Row>
                            <br />

                            <Row type="flex" justify="space-between" gutter={16}>
                                {[
                                    {label: "Upload Quote", docType: "Quote"},
                                    {label: "Upload Contract", docType: "Contract"},
                                    {label: "Upload Signed Contract", docType: "Signed Contract"},
                                ].map((i, key) => {
                                    const {docType} = i;
                                    return (
                                        <Col span={8} key={key}>
                                            <span>{docType}</span>
                                            <Document
                                                name="document" {...i}
                                                document={getDocument(docType)}
                                                onUpload={handleUpload}
                                                onRemove={onDelete}
                                                application={id}
                                            />
                                        </Col>
                                    )
                                })}
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Form>
        )
    }
    componentDidMount() {
        const {location: {state: {from} = {}}, landlord: {id: appId}} = this.props;
        if (appId) return;
        const [full, page] = from.match(/page=(\d+)/) || ['', 1];
        return this.props.fetchLandlords(page);
    }
    render() {
        return (
            <div>
                {this.renderBreadcrump()}
                {this.renderProfile()}
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const {match: {params: {id}}} = ownProps;
    const data = [...state.landlords.data];
    const index = data.findIndex(a => a.id == id);
    const previous = data[index-1] || {};
    const next = data[index+1] || {};
    return {
        landlord: {...data[index]},
        previous,
        next,
        isFetching: state.landlords.isFetching
    }
}

const WrappedForm = Form.create()(Landlord)
export default connect(mapStateToProps, {
    fetchLandlords,
    updateLandlord,
    uploadDocument,
    deleteDocument
})(WrappedForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Landlord.js